import { createSlice } from "@reduxjs/toolkit";

// Helper function to get initial auth state from localStorage
const getInitialAuthState = () => {
  const token = localStorage.getItem("authToken");
  const refreshToken = localStorage.getItem("refreshToken");
  const user = localStorage.getItem("user");
  
  if (token && user) {
    return {
      user: JSON.parse(user),
      isAuthenticated: true,
      token: token,
      refreshToken: refreshToken,
    };
  }
  
  return {
    user: null,
    isAuthenticated: false,
    token: null,
    refreshToken: null,
  };
};

const authSlice = createSlice({
  name: "auth",
  initialState: getInitialAuthState(),
  reducers: {
    setUser: (state, action) => {
      console.log('Setting user in authSlice:', action.payload);
      state.user = action.payload;
      if (action.payload) {
        localStorage.setItem("user", JSON.stringify(action.payload));
      } else {
        localStorage.removeItem("user");
      }
    },
    setIsAuthenticated: (state, action) => {
      console.log('Setting isAuthenticated in authSlice:', action.payload);
      state.isAuthenticated = action.payload;
      if (!action.payload) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("user");
        state.token = null;
        state.refreshToken = null;
      }
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.token = null;
      state.refreshToken = null;
      localStorage.removeItem("authToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("userName");
    },
    setToken: (state, action) => {
      state.token = action.payload;
      if (action.payload) {
        localStorage.setItem("authToken", action.payload);
      } else {
        localStorage.removeItem("authToken");
      }
    },
    setRefreshToken: (state, action) => {
      state.refreshToken = action.payload;
      if (action.payload) {
        localStorage.setItem("refreshToken", action.payload);
      } else {
        localStorage.removeItem("refreshToken");
      }
    },
  },
});

export const { setUser, setIsAuthenticated, logout, setToken, setRefreshToken } = authSlice.actions;
export default authSlice.reducer;